/**
 * @description Storage keys (enum)
 */
export enum StorageKeysEnum {
  /** Session Id */
  SessionId = 'session-id',
  /** 登入授權 (會員主檔 & Access Token) */
  Authorization = 'authorization',
  /** 應用熊寶悄悄話 (繳費提示區塊) */
  ApplyReminder = 'apply-reminder'
};
